<template>
  <div>
    <vue3-chart-js
      :id="lineChart.id"
      :type="lineChart.type"
      :data="lineChart.data"
      :options="lineChart.options"
    ></vue3-chart-js>
  </div>
</template>

<script>
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import useGlobalHelpers from '@/mixins/useGlobalHelpers.js'

export default {
  name: 'App',
  components: {
    Vue3ChartJs,
  },
  props: {
    timeView: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const i18n = useI18n({ useScope: 'global' })
    const { dollarFormatting } = useGlobalHelpers()

    const lineChart = ref({
      id: 'line',
      type: 'line',
      data: {
        labels: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'], // how many bars are gonna show on the chart
        datasets: props.timeView,
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              title: function (tooltipItem) {
                return i18n.t(tooltipItem[0].dataset.title)
              },
              label: function (context) {
                return '$' + dollarFormatting(parseFloat(context.raw) * 100) || ''
              },
              labelColor: function (context) {
                return {
                  borderColor: context.dataset.borderColor,
                  backgroundColor: context.dataset.borderColor,
                  borderWidth: 2,
                  borderRadius: 2,
                }
              },
            },
            enabled: true,
          },
        },
        scales: {
          x: {
            stacked: false,
            grid: {
              display: false,
            },
            ticks: {
              color: '#a3a8ad',
              font: {
                size: 10,
              },
            },
          },
          y: {
            beginAtZero: true,
            stacked: false,
            grid: {
              color: 'rgba(230, 230, 230, 0.49)',
              drawBorder: false,
            },
            ticks: {
              color: '#a3a8ad',
              font: {
                size: 10,
              },
              callback: function (label) {
                if (label > 1000) return `$${label / 1000}k`
                return `$${label}`
              },
            },
          },
        },
      },
    })

    return {
      lineChart,
    }
  },
}
</script>
